/**
 * 单域名后台的路由前缀：`/platform/...` 是平台后台，`/hq/...` 是总会后台。
 * 组织会务模块自己的路由也以 `/org` 开头，所以总会入口不能叫 `/org`。
 *
 * 两者都不是（按机构域名访问）时为空串，路由与今天一致。前缀只在页面加载时按地址取一次，
 * 之后站内跳转都在同一前缀下；接口仍走根下的 `/api/v1`，与前缀无关。
 */
const ENTRY_BASENAMES = ['/platform', '/hq'] as const;

/** 这个路径属于哪个后台入口；不属于任何入口回空串 */
export function basenameOf(pathname: string): string {
  const path = pathname.toLowerCase();
  return (
    ENTRY_BASENAMES.find((base) => path === base || path.startsWith(`${base}/`)) ?? ''
  );
}

/** 当前页面所在的后台入口前缀 */
export function currentBasename(): string {
  return basenameOf(window.location.pathname);
}

/** 把站内路由路径（如 `/login`）变成带入口前缀的整页地址 */
export function withBasename(path: string, basename = currentBasename()): string {
  return `${basename}${path}`;
}

/** 整页地址去掉入口前缀，得到站内路由路径；不带该前缀时原样返回 */
export function stripBasename(pathname: string, basename = currentBasename()): string {
  if (!basename) return pathname;
  const rest = pathname.slice(basename.length);
  return rest.startsWith('/') ? rest : `/${rest}`;
}
